// reducers.js
const initialState = {
    isAuthenticated: false,
    user: null,
    role: null,
    error: null,
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.token,
                role: action.payload.role,
                error: null,
            };
        case 'LOGIN_FAILURE':
            return {
                ...state,
                isAuthenticated: false,
                error: action.payload,
            };
        case 'LOGOUT': // ログアウトアクションの処理
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                role: null,
                error: null,
            };
        case 'RESTORE_ROLE':  // restoreRoleアクションでroleをセット
            return {
                ...state,
                role: action.payload,
            };
        default:
            return state;
    }
};

export default rootReducer;